import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./styles/globals.css";
import { applyTheme, getStoredThemePreference, initThemeLifecycle } from "./components/ThemeToggle";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initCapacitorNative } from "./native/capacitorInit";

applyTheme(getStoredThemePreference());
initThemeLifecycle();
initCapacitorNative();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
